import React, { useContext, useEffect, useState } from "react";
import { LuPlus } from "react-icons/lu";
import { RiDeleteBin6Line } from "react-icons/ri";
import { MdOutlineCancel } from "react-icons/md";
import { useToast } from "../ToastContext";
import Utils from "../../utils/utils";
import { useAppLibs } from "../../ContextProvider/AppLib_Provider";

const CreateProject = ({ props }) => {
  const { setProjects, projects, onClose } = props;
  const { Projects } = useAppLibs();
  const token = Utils.getToken();
  const SERVER_URL = `${process.env.REACT_APP_SERVER_URL}`;
  const showToast = useToast();
  const [docs, setDocs] = useState([{ name: "", url: "" }]);
  const [formData, setFormData] = useState({
    title: "",
    description: "",
    instruction: "",
    subject: "",
    level: 1,
    maxMarks: 0,
  });
  const LEVEL = Projects.LEVEL;
  const SUBJECT = Projects.SUBJECT;

  const [createClicked, setCreateClicked] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validateURL = function (url) {
    try {
      new URL(url);
      return true;
    } catch {
      return false;
    }
  };

  const handleResetForm = () => {
    setFormData({
      title: "",
      description: "",
      instruction: "",
      subject: "",
      level: 1,
      maxMarks: 0,
    });
  };

  const handleAddDocs = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDocs([...docs, { name: "", url: "" }]);
  };

  const handleDeleteDocs = (index) => {
    const updatedQuestions = docs.filter((_, i) => i !== index);
    setDocs(updatedQuestions);
  };

  const handleQuestionChange = (index, field, value) => {
    const updatedQuestions = [...docs];
    updatedQuestions[index][field] = value;
    setDocs(updatedQuestions);
  };

  // =======================    APIs
  const HandleProjectCreation = async (e) => {
    e.preventDefault();
    setCreateClicked((prev) => true);
    formData["createdAt"] = Utils.getCurrentTime();

    for (let d = 0; d < docs.length; d++) {
      var url = docs[d].url;
      if (!url || !validateURL(url)) {
        showToast(
          "Please enter the valid link for " + (d + 1) + " docs!",
          "warning",
          true,
          2000
        );
        return;
      }
    }

    formData["docs"] = docs;
    try {
      const result = await Projects.createProject(formData);
      if (result.success) {
        setCreateClicked(false);
        const newArr = [result.data, ...projects];
        setProjects((prev) => newArr);
        showToast("Project created successfully!", "success", true, 2000);
        handleResetForm();
        onClose();
      } else {
        showToast(result.error, "error", true, 2000);
      }
    } catch (error) {
      setCreateClicked(false);
      console.log("Error In catch in ProjectCreation: ", error);
      alert(`Something went wrong !!`);
    }
  };

  return (
    <div bkl="CreateProjectForm">
      <div className="menu bg-[#FFFFFF] text-base-content w-full h-full p-4 rounded-l-lg">
        <div>
          <p className="text-lg bold">Create a new Project</p>
        </div>
        <form onSubmit={HandleProjectCreation} className="h-full">
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Project Name :</span>
              <input
                name="title"
                value={formData.title}
                onChange={handleInputChange}
                required
                placeholder="Please enter title project title.."
                className="input-sm px-4 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Description :</span>
              <textarea
                name="description"
                value={formData.description}
                onChange={handleInputChange}
                placeholder="Please enter the description of the project.."
                className="w-full px-4 py-2 min-h-12 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-full">
              <span className="label ">Instruction :</span>
              <textarea
                name="instruction"
                value={formData.instruction}
                onChange={handleInputChange}
                placeholder="Enter the instruction optional.."
                className="w-full px-4 py-2 min-h-12 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>
          <div className="flex items-center gap-2 mt-2 w-full">
            <label className="form-control w-[40%]">
              <span className="label ">Project In :</span>
              <select
                name="subject"
                value={formData.subject || ""}
                onChange={handleInputChange}
                required
                className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
              >
                <option
                  value={""}
                  key={"Select Subject"}
                  disabled
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  Select Subject
                </option>
                {Object.keys(SUBJECT).map((sub) => (
                  <option value={sub} key={sub}>
                    {SUBJECT[sub]}
                  </option>
                ))}
              </select>
            </label>
            <label className="form-control w-[40%]">
              <span className="label ">Difficulty :</span>
              <select
                name="level"
                value={formData.level || ""}
                onChange={handleInputChange}
                required
                className="select select-sm outline-gray-300 outline-1
                      focus:border-pink-500 outline focus:outline-none"
              >
                <option
                  value={""}
                  key={"Select Difficulty"}
                  disabled
                  style={{ fontWeight: "bold", color: "black" }}
                >
                  Select Difficulty
                </option>
                {Object.keys(LEVEL).map((sub) => (
                  <option value={sub} key={sub}>
                    {LEVEL[sub].name}
                  </option>
                ))}
              </select>
            </label>
            <label className="form-control w-[20%] transition-all duration-200">
              <span className="label ">Maximum Marks :</span>
              <input
                type="tel"
                placeholder="Max Marks"
                value={formData.maxMarks}
                pattern="[0-9]*"
                inputMode="numeric"
                name="maxMarks"
                onChange={(e) => {
                  e.preventDefault();
                  e.stopPropagation();
                  const value = e.target.value;
                  if (/^\d*$/.test(value)) {
                    handleInputChange(e);
                  } else {
                    alert("Please enter numbers only.");
                    return false;
                  }
                }}
                className="input-sm max-w-[120px] px-2 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
              />
            </label>
          </div>

          <div
            className="flex items-center gap-4 mt-2 w-full "
            key={"Documents URL-Label"}
          >
            <label className="form-control w-[45%]">
              <span className="label font-semibold">Documents Name</span>
            </label>

            <label className="form-control w-[45%]">
              <span className="label font-semibold">URL</span>
            </label>
            <label className="form-control  w-[5%]"></label>
          </div>

          {docs.map((q, index) => (
            <div
              className="flex items-center gap-4 mt-2 w-full"
              key={"docs" + index}
            >
              <label className="form-control w-[45%] ">
                <input
                  type="text"
                  placeholder={`Doc ${index + 1}`}
                  value={q.name}
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleQuestionChange(index, "name", e.target.value);
                  }}
                  required
                  className="w-full px-4 py-2 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                />
              </label>

              <label className="form-control w-[45%]  ">
                <input
                  type="url"
                  placeholder="URL"
                  value={q.url}
                  name="url"
                  onChange={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    handleQuestionChange(index, "url", e.target.value);
                  }}
                  className="input-sm px-2 py-3 rounded-lg bg-gray-50 border focus:border-pink-500 focus:bg-white focus:outline-none"
                />
              </label>

              <label className="form-control w-[12%] flex justify-center items-center ">
                {index == docs.length - 1 ? (
                  <div className=" w-full flex gap-2 justify-between">
                    <button
                      onClick={handleAddDocs}
                      className="flex items-center justify-center w-6 h-6 rounded-full border border-pink-700 bg-white shadow-md hover:bg-pink-50 active:bg-pink-100 focus:outline-none"
                    >
                      <LuPlus className="w-5 h-5 text-pink-700" />
                    </button>
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDeleteDocs(index);
                      }}
                      className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                    >
                      <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                    </button>
                  </div>
                ) : (
                  <div className=" w-full flex justify-end">
                    <button
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        handleDeleteDocs(index);
                      }}
                      className="flex items-center justify-center w-6 h-6 rounded-full border border-red-700 bg-white shadow-md hover:bg-red-50 active:bg-pink-100 focus:outline-none "
                    >
                      <RiDeleteBin6Line className="w-4 h-4 text-red-500" />
                    </button>
                  </div>
                )}
              </label>
            </div>
          ))}

          <div className="gap-2 bg-white mt-4 z-10 flex justify-between sticky bottom-1">
            <div className="flex gap-2">
              <button
                className={`${
                  createClicked ? "cursor-not-allowed" : "cursor-pointer"
                } px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-green-600 rounded-lg text-green-600 hover:text-green-800 hover:border-green-800 hover:shadow-lg`}
                type="submit"
                disabled={createClicked}
              >
                CREATE
              </button>
              <button
                htmlFor="my-drawer-8"
                aria-label="close sidebar"
                className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-orange-600 rounded-lg text-orange-600 hover:text-orange-800 hover:border-orange-800 hover:shadow-lg "
                onClick={(e) => {
                  e.stopPropagation();
                  e.preventDefault();
                  handleResetForm();
                }}
              >
                RESET
              </button>
            </div>
            <label
              htmlFor="my-drawer-8"
              aria-label="close sidebar"
              className="px-3 py-1 flex justify-center items-center gap-1 btn-xs  tracking-[.1em] uppercase border border-red-600 rounded-lg text-red-600 hover:text-red-800 hover:border-red-800 hover:shadow-lg "
              onClick={(e) => {
                e.stopPropagation();
                e.preventDefault();
                handleResetForm();
              }}
            >
              CLOSE
            </label>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateProject;
